'use strict';

angular.module('substoreApp.controllers')
    .controller('processingController', ['$scope', 'sessionData', 'webtrekk',
        function ($scope, sessionData, webtrekk) {

            $scope.breadcrumb.init("your_order");

            if (sessionData.fault && !sessionData.fault.positiveError) {
                $scope.go("/error");
            } else if (!sessionData.fault) {
                $scope.go("/");
            } else {
                $scope.data = sessionData.fault;
                webtrekk.track('positive_backend_error', {});
                $scope.$on('$routeChangeStart', function (scope, next, current) {
                    if (next.$$route.originalPath.indexOf("/processing") < 0)
                        sessionData.fault = undefined;
                    sessionData.deleteCurrentSubscription();
                });
            }
        }]);
